module.exports = __webpack_public_path__ + "static/img/footOneImg4.40d85c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footOneImg4.png
// module id = pW8l
// module chunks = 1